import { FlagKeys } from '@bettermode/flags/registry'

import { useClientFlag } from '../flags/index.js'

/**
 * A shared library package shouldn't read flags directly — `packages/flags/AGENTS.md`
 * puts client flag hooks in `packages/web/src/client/featureFlags/hooks/`. That rule
 * assumes the consumer is `web`; a component rendered from `react-components` cannot
 * reach a hook living in `web`, so it reads the same SSR snapshot through the shared
 * `flags/` context instead — which is the abstraction that makes it legitimate rather
 * than a deferred exception.
 *
 * `useClientFlag` falls back to the flag's registry `defaultValue` (`true` here,
 * from its `default-on` tag) whenever no `FlagsSnapshotProvider` is mounted —
 * Storybook, this package's test harness, dev-portal — so the containment boundary
 * stays on in those trees instead of throwing or silently going off. The trade
 * versus evaluating in the browser is that a PostHog change lands on the next
 * server-rendered response, not mid-session.
 */
export const useHtmlContentBoundaryEnabled = (): boolean =>
  useClientFlag(FlagKeys.HtmlContentBoundary)
